module.exports = __webpack_public_path__ + "assets/e9885578ce6c3526b87af77dc46927b0.svg";